export default __webpack_public_path__ + "static/media/garanti.f20c2db8.png";